import React, { memo, useState, useEffect, useRef, useCallback } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles, useTheme } from '@mui/styles';
import { getUrl } from '@utils/ApiAction';// loginGame, postUrl
// import { storePlayerId } from '@actions';
import useNotificationLoading from '@utils/useNotificationLoading';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { currencyFormat } from '@utils/Tools';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { FreeMode } from 'swiper/modules';
import 'swiper/css/bundle';
import moment from 'moment-timezone';
// import { storePaths } from '@utils/Tools';

// MUI
import { Dialog } from '@mui/material';

// ICON
import { FiX } from "react-icons/fi";
import { GoTriangleDown } from "react-icons/go";

// import { FaLink } from "react-icons/fa";

//LAYOUT & COMPONENTS
import NoticeItem from '@components/NoticeItem';
import DialogDesign from '@components/DialogDesign';
// import VerifyEmailDialog from '@components/VerifyEmailDialog';
// import GeneologyDialog from '@components/GeneologyDialog';
import VideoSwiper from '@components/VideoSwiper';



const Home = memo(() => {
    // const theme = useTheme();
    // const styles = useStyles();
    const { t, i18n } = useTranslation();
    const isMountedRef = useRef(null);
    // let navigate = useNavigate();
    // let location = useLocation();
    // const dispatch = useDispatch();
    // const { accessToken, accountSetting } = useSelector(state => state.general);
    // const { player_id, email_verified_at } = useSelector(state => state.user);
    const { addAlert, setLoading } = useNotificationLoading();
    const [walletTooltip, setWalletTooltip] = useState({});
    const [data, setData] = useState({});
    const [pocketbook, setPocketbook] = useState({});
    const [videos, setVideos] = useState({});
    const [geneologyDialog, setGeneologyDialog] = useState(false);
    const { username } = useSelector(state => state.user);
    const [dialogInfo, setDialogInfo] = useState({
        open: false,
        key: 0,
        data: null
    });
    const language = _.includes(['cn', 'zhtw'], i18n.language) ? 'cn' : 'en';

    useEffect(() => {
        isMountedRef.current = true;
        setLoading(true);
        getUrl('dashboard').then(response => {
            if (response.status && isMountedRef.current) {
                setData({ ...data, ...response.data });
                if (_.size(response?.data?.announcements) > 0) {
                    setDialogInfo({
                        open: true,
                        key: 1,
                        data: response?.data?.announcements[0]
                    });
                }
            }
        }).catch(error => {
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        }).finally(() => {
            setLoading(false);
        });

        getUrl('/member-ge-pocketbook').then(response => {
            if (response.status && isMountedRef.current) {
                setPocketbook(response.data);
            }
        }).catch(error => {
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        }).finally(() => {
            setLoading(false);
        });

        let apiparams ={ 
            'languages':i18n.resolvedLanguage,
        };
        getUrl(`/video`, apiparams).then(response => {
            if (response.status) {
                setVideos(response?.data);
            }
        }).catch(error => {
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        });

        return () => isMountedRef.current = false;
    }, []);

    const WalletInfo = (props) => {
        let { decimal, balance, locked_balance } = props.info;
        let withdrawableBalance = parseFloat(balance) - parseFloat(locked_balance || 0);
        balance = currencyFormat(parseFloat(balance), decimal);
        locked_balance = currencyFormat(parseFloat(locked_balance || 0), decimal);
        withdrawableBalance = currencyFormat(withdrawableBalance, decimal);

        return (
            <div className='p-t-20 w-full'>
                {/* <p>{`${t('home.currentBalance')}: $ ${balance}`}</p> */}
                <div className='flex-sb-m w-full p-b-5'>
                    <p className='fs-14'>{t('home.withdrawable')}</p>
                    <p>{withdrawableBalance}</p>
                </div>
                <div className='flex-sb-m w-full'>
                    <p className='fs-14'>{t('home.locked')}</p>
                    <p>{locked_balance}</p>
                </div>
            </div>
        )
    }

    const showWalletTooltip = (walletId) => {
        setWalletTooltip({ ...walletTooltip, [walletId]: true })
    }

    const hideWalletTooltip = (walletId) => {
        setWalletTooltip({ ...walletTooltip, [walletId]: false })
    }

    //WalletDesign
    const WALLET_COLOUR = {
        1: 'gradient-main',
        2: 'gradient-main',
        3: 'gradient-main'
    }

    const WALLET_ICON = {
        1: 'logo-dlt.png',
        2: 'logo-usdt.png',
        3: 'logo-rp.png'
    }

    //Dialog
    const shareLink = useRef(null);
    const handleClickOpenGeneologyDialog = () => {
        setGeneologyDialog(true);
    };
    const handleCloseGeneologyDialog = () => {
        setGeneologyDialog(false);
    };
    const copyShareLink = useCallback((e) => {
        shareLink.current.select();
        document.execCommand('copy');
        e.target.focus();

        addAlert('', t('general.copied'), "success");
    }, []);

    const closeDialog = () => {
        if (_.size(data?.announcements) > dialogInfo.key) {
            setDialogInfo({ ...dialogInfo, key: dialogInfo.key + 1, data: data?.announcements[dialogInfo.key] });
        } else {
            setDialogInfo({
                open: false,
                key: 0,
                data: null
            });
        }
    }

    //Server Date
    const [serverTime, setServerTime] = useState("");
    useEffect(() => {
        moment.tz.setDefault("Asia/Kuala_Lumpur");
        // let secTimer = setInterval(() => {
            setServerTime(moment().format("DD / MM / YYYY"))
        // }, 1000)

        // return () => clearInterval(secTimer);
    }, [])

    //Rule Dialog
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [rule2Dialog, setRule2Dialog] = useState(false);

    const [ruleDialog, setRuleDialog] = React.useState({
        open: false,
        data: {
            img: '',
            title: '',
            desc: '',
        }
    });

    const openRuleDialog = (img, title, desc) => {
        setRuleDialog({ ...ruleDialog, open: true, data: { img: img, title: title, desc: desc} });
    };

    const closeRuleDialog = () => {
        setRuleDialog({ ...ruleDialog, open: false });
    };


    const video = () => {
        return (
            <div style={{ marginBottom: 10, paddingTop:  0, marginTop:-20  }}>
                {
                    _.size(videos) > 0 ?
                    (
                        videos.length > 1 
                        ? 
                            (
                                    <div>
                                        <div className='w-full flex-sb-m p-b-10'>
                                            <p className='fs-21 p-b-15  cl-theme'><b>{t('title.video')}</b></p>
                                            {/* <p>查看全部</p> */}
                                        </div>
                                        <VideoSwiper videos={videos} />
                                    </div>
                            ) 
                        : 
                            (
                                videos.map((video) => (
                                    <iframe
                                        key={video.id}
                                        title={`dashboard_video_${video.id}`}
                                        src={video.url}
                                        width="100%"
                                        height="250"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                        style={{ borderRadius: 10, boxShadow: '0 6px 6px 0 #0002', marginBottom: 20 }}
                                    />
                                ))
                            )
                    )
                        :
                       null

                }
                
            </div>
        )
    }

    function formatTo9Decimals(value) {
        value = String(value);
  const [integer, decimal = ''] = value.split('.');
  const trimmed = decimal.slice(0, 9); // Cut without rounding
  const padded = trimmed.padEnd(9, '0'); // Ensure exactly 9 digits
  return `${integer}.${padded}`;

    }

    return (
        <div className='flex-col app-header-margin cl-white' style={{ gap: 50 }}>
            <div>
                <div className='p-b-15 txt-center flex-col' style={{gap:5}}>
                    <p className='fs-15'>{serverTime}</p>
                    <p className='fs-21 cl-theme'><b>0.1G {t('about.dailyRevenue')}</b></p>
                </div>
                <div className='w-full flex-sb-m' style={{ gap: 15 }}>
                    <div className='txt-center mining-area-box' style={{width:'50%'}}>                        
                        <p className='cl-theme produce-title'>LTC</p>
                        <p className="digitSize p-t-5" style={{wordBreak:'break-all'}}>{Number(formatTo9Decimals(pocketbook?.LTC ?? 0.00000000))}</p>
                    </div>
                    <div className='txt-center mining-area-box' style={{width:'50%'}}>
                        <p className='cl-theme produce-title'>DOGE</p>
                        <p className="digitSize p-t-5" style={{wordBreak:'break-all'}}>{Number(formatTo9Decimals(pocketbook?.DOGE ?? 0.00000000))}</p>
                    </div>
                </div>
                <div className='w-full flex-sb-m p-t-15' style={{ gap: 15 }}>
                <div className='txt-center mining-area-box' style={{width:'50%'}}>
                        <p className='cl-theme produce-title'>Bells</p>
                        <p className="digitSize p-t-5" style={{wordBreak:'break-all'}}>{Number(formatTo9Decimals(pocketbook?.BELLS ?? 0.00000000))}</p>
                    </div>
                    <div className='txt-center mining-area-box' style={{width:'50%'}}>
                        <p className='cl-theme produce-title'>LKY</p>
                        <p className="digitSize p-t-5" style={{wordBreak:'break-all'}}>{Number(formatTo9Decimals(pocketbook?.LKY ?? 0.00000000))}</p>
                    </div>
                </div>
            </div>

            <div>
                <p className='fs-21 p-b-15 cl-theme txt-title'><b>{t('about.ruleTitle')}</b></p>
                <div className='flex-w flex-sb-m' style={{ gap: 15 }}>
                    <div className='rule-box pointer translateY' onClick={() => openRuleDialog('/images/home/rule/machine.png', t('about.ruleTitle1'), t('about.ruleDesc1'))}>
                        <div className='rule-bg'>
                            <p className='fs-14'>{t('about.ruleTitle1')}</p>
                        </div>
                        <div>
                            <img src='/images/home/rule/machine.png' alt="rule" className='w-full' />
                        </div>
                    </div>
                    <div className='rule-box pointer translateY' onClick={() => setRule2Dialog(true)}>
                        <div className='rule-bg'>
                            <p className='fs-14'>{t('about.ruleTitle2')}</p>
                        </div>
                        <div>
                            <img src='/images/home/rule/electric.png' alt="rule" className='w-full' />
                        </div>
                    </div>
                    <div className='rule-box pointer translateY' onClick={() => openRuleDialog('/images/home/rule/logistic.png', t('about.ruleTitle3'), t('about.ruleDesc3'))}>
                        <div className='rule-bg'>
                            <p className='fs-14'>{t('about.ruleTitle3')}</p>
                        </div>
                        <div>
                            <img src='/images/home/rule/logistic.png' alt="rule" className='w-full' />
                        </div>
                    </div>
                    <div className='rule-box pointer translateY' onClick={() => openRuleDialog('/images/home/rule/global.png', t('about.ruleTitle4'), t('about.ruleDesc4'))}>
                        <div className='rule-bg'>
                            <p className='fs-14'>{t('about.ruleTitle4')}</p>
                        </div>
                        <div>
                            <img src='/images/home/rule/global.png' alt="rule" className='w-full' />
                        </div>
                    </div>
                    <div className='rule-box pointer translateY' style={{width:'100%'}} onClick={() => openRuleDialog('/images/home/rule/customs2.png', t('about.ruleTitle5'),  t('about.ruleDesc5'))}>
                        <div className='rule-bg'>
                            <p className='fs-14'>{t('about.ruleTitle5')}</p>
                        </div>
                        <div>
                            <img src='/images/home/rule/customs.png' alt="rule" className='w-full' />
                        </div>
                    </div>                  
                </div>
            </div>

            <Dialog
                maxWidth="xs"
                fullWidth
                open={ruleDialog.open}
                onClose={closeRuleDialog}
            >
                <div className='gradient-theme pos-relative dialog-frame'>

                    {/* Dialog Content */}
                    <div className='dialog-content-outer-bkg'>
                        <div className='dialog-content-bkg' style={{ padding: 0 }}>
                            {/* Button Close */}
                            <div className='dialog-btn-close' onClick={closeRuleDialog}>
                                <div className=' flex-c-m animate-spin pointer'>
                                    <FiX className='fs-23 cl-theme' />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <img src={ruleDialog.data.img} alt="rule" className='w-full bor15' />
                                </div>
                                <div className='p-lr-20 p-t-20 p-b-40'>
                                    <p className='fs-18 p-b-5 cl-theme'><b>{ruleDialog.data.title}</b></p>
                                    <p className='fs-14 lh-12'>{ruleDialog.data.desc}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            {/* //FOR RULE 2 ONLY */}
            <Dialog
                maxWidth="xs"
                fullWidth
                open={rule2Dialog}
                onClose={() => setRule2Dialog(false)}
                onClick={() => setRule2Dialog(false)}
            >
                <div className='gradient-theme pos-relative dialog-frame'>

                    {/* Dialog Content */}
                    <div className='dialog-content-outer-bkg'>
                        <div className='dialog-content-bkg' style={{ padding: 0 }}>
                            {/* Button Close */}
                            <div className='dialog-btn-close' onClick={() => setRule2Dialog(false)}>
                                <div className=' flex-c-m animate-spin pointer' style={{filter:''}}>
                                    <FiX className='fs-23 cl-theme' />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <img src='/images/home/rule/electric.png' alt="rule" className='w-full bor15' />
                                </div>
                                <div className='p-lr-20 p-t-20 p-b-40'>
                                    <p className='fs-18 p-b-5 cl-theme'><b>{t('about.ruleTitle2')}</b></p>
                                    <div className='fs-14 p-t-5 flex-col w-full cl-white' style={{gap:5}}>
                                        <p className='lh-12'><b className='cl-label'>{t('about.ruleDesc2a')}</b>:<br/>BITMAIN ANTMINER L9</p>
                                        <p className='lh-12'><b className='cl-label'>{t('about.ruleDesc2b')}</b>:<br/>LTC / DOGE / BELLS / JKC / LKY / PEP</p>
                                        <p className='lh-12'><b className='cl-label'>{t('about.ruleDesc2c')}</b>:<br/>16G</p>
                                        <p className='lh-12'><b className='cl-label'>{t('about.ruleDesc2d')}</b>:<br/>3360W ± 5%</p>
                                        <p className='lh-12'><b className='cl-label'>{t('about.ruleDesc2e')}  @25°C.J/G</b>:<br/>210± 5%</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <div>
                <div className='p-b-40'>
                    <p className='fs-21 p-t-15 p-b-5  cl-theme'><b>{t('about.mineArea')}</b></p>
                    <p className='fs-15'>{t('about.mineAreaDesc')}</p>
                </div>
                <div className='w-full flex-col' style={{gap:40}}>
                <div className='flex-m w-full mining-area-box' style={{gap:24}}>
                    <div style={{ width: 150, marginTop:-30, maxWidth:'45%' }}>
                        <img src='/images/home/about1.png' alt="about" className='w-full' />
                    </div>
                    <div style={{width:'55%', wordBreak:'break-all'}}>
                        <p className='fs-24 cl-theme'>330mw</p>
                        <p className='fs-15'>{t('about.mineVolume')}</p>
                    </div>
                </div>
                <div className='flex-m w-full mining-area-box' style={{gap:24}}>
                    <div style={{ width: 150, marginTop:-30, maxWidth:'45%' }}>
                        <img src='/images/home/about2.png' alt="about" className='w-full' />
                    </div>
                    <div style={{width:'55%', wordBreak:'break-all'}}>
                        <p className='fs-24 cl-theme'>500,000</p>
                        <p className='fs-15'>{t('about.mineUser')}</p>
                    </div>
                </div>
                <div className='flex-m w-full mining-area-box' style={{gap:24}}>
                    <div style={{ width: 150, marginTop:-30, maxWidth:'45%' }}>
                        <img src='/images/home/about3.png' alt="about" className='w-full' />
                    </div>
                    <div style={{width:'55%', wordBreak:'break-all'}}>
                        <p className='fs-24 cl-theme'>4</p>
                        <p className='fs-15'>{t('about.mineCountry')}</p>
                    </div>
                </div>
                </div>
            </div>

            <div>
                <div className='p-b-10'>
                    <p className='fs-21 p-b-5 cl-theme'><b>{t('about.machineIntro')}</b></p>
                    <p className='fs-15'>{t('about.machineDesc')}</p>
                </div>

                <div>
                    <div className='flex-m w-full' style={{ gap: 10 }}>
                        <div style={{ width: 150, maxWidth:'40%', minWidth:100 }}>
                            <img src='/images/home/process1.png' alt="process" className='w-full' />
                        </div>
                        <div style={{width:'70%'}}>
                            <p className='fs-14 p-b-5 cl-theme'><b>{t('about.processTitle1')}</b></p>
                            <p className='fs-14'>{t('about.processDesc1')}</p>
                        </div>
                    </div>

                    <div className='p-lr-50'>
                        <div className='w-full' style={{ height: 10, borderLeft: '1px dashed #fff', borderBottom: '1px dashed #fff' }} />
                        <div className='w-full' style={{ height: 20, borderRight: '1px dashed #fff' }} />
                        <div className='w-full flex-r' style={{ lineHeight: 0 }}>
                            <GoTriangleDown className='clwhite fs-21' style={{ marginRight: -10, marginTop: -6 }} />
                        </div>
                    </div>

                    <div className='flex-m flex-row-rev w-full' style={{ gap: 10, marginTop:-30 }}>
                        <div style={{ width: 150, maxWidth:'40%', minWidth:100 }}>
                            <img src='/images/home/process2.png' alt="process" className='w-full' />
                        </div>
                        <div className='txt-right' style={{width:'70%'}}>
                            <p className='fs-14 p-b-5 cl-theme'><b>{t('about.processTitle2')}</b></p>
                            <p className='fs-14'>{t('about.processDesc2')}</p>
                        </div>
                    </div>

                    <div className='p-lr-50'>
                        <div className='w-full' style={{ height: 10, borderRight: '1px dashed #fff', borderBottom: '1px dashed #fff' }} />
                        <div className='w-full' style={{ height: 20, borderLeft: '1px dashed #fff' }} />
                        <div className='w-full' style={{ lineHeight: 0 }}>
                            <GoTriangleDown className='clwhite fs-21' style={{ marginLeft: -10, marginTop: -6 }} />
                        </div>
                    </div>

                    <div className='flex-m  w-full' style={{ gap: 10, marginTop:-30 }}>
                        <div style={{ width: 150, maxWidth:'40%', minWidth:100 }}>
                            <img src='/images/home/process3.png' alt="process" className='w-full' />
                        </div>
                        <div style={{width:'70%'}}>
                            <p className='fs-14 p-b-5 cl-theme'><b>{t('about.processTitle3')}</b></p>
                            <p className='fs-14'>{t('about.processDesc3')}</p>
                        </div>
                    </div>

                    <div className='p-lr-50'>
                        <div className='w-full' style={{ height: 10, borderLeft: '1px dashed #fff', borderBottom: '1px dashed #fff' }} />
                        <div className='w-full' style={{ height: 20, borderRight: '1px dashed #fff' }} />
                        <div className='w-full flex-r' style={{ lineHeight: 0 }}>
                            <GoTriangleDown className='clwhite fs-21' style={{ marginRight: -10, marginTop: -6 }} />
                        </div>
                    </div>

                    <div className='flex-m w-full flex-row-rev' style={{ gap: 10, marginTop:-30 }}>
                        <div style={{ width: 150, maxWidth:'40%', minWidth:100 }}>
                            <img src='/images/home/process4.png' alt="process" className='w-full' />
                        </div>
                        <div className='txt-right' style={{width:'70%'}}>
                            <p className='fs-14 p-b-5 cl-theme'><b>{t('about.processTitle4')}</b></p>
                            <p className='fs-14'>{t('about.processDesc4')}</p>
                        </div>
                    </div>
                </div>
            </div>

            {video()}
            
            {/* wallet balance */}
            {/* <div className='cl-white'>
                <div style={{ width: '73%', paddingTop: 10 }}>
                    <p className='fs-21 p-b-10 txt-title txt-truncate'>{t('home.hi')} {username},</p>
                </div> */}
                {/* <div className='w-full flex-sb-m'>
                    <div>
                        <p className='fs-14'>{_.find(data.wallets, {id:2})?.name[i18n.resolvedLanguage]} {t('withdrawal.balance')}</p>
                        <p className='fs-21 p-t-5'><b>{currencyFormat(_.find(data.wallets, {id:2})?.balance||0)}</b></p>
                    </div>
                    <div style={{ width: 60 }}>
                        <img src='/images/wallet/coin-usdt-theme.png' alt='coin' />
                    </div>
                </div> */}

                {/* <div className='p-t-20'>
                    {data.wallets && _.map(data.wallets, (_wallet, wallet_key) => {

                        return (
                            <div key={wallet_key}> */}
                                {/* <div className={styles.walletBoxStyle}>
                                <div className="dis-flex flex-t flex-l" style={{ flexDirection: 'column' }} >
                                    <div className="flex-c-m" style={{ gap: 8, flexDirection: 'row' }}>
                                        <Typography sx={{ color: '#101828', fontWeight: 'bold' }} variant="subtitle2" >{_wallet.name[i18n.resolvedLanguage]}</Typography>
                                        
                                    </div>
                                    <Typography variant="body2" sx={{ color: '#667085' }}>{t('home.currentBalance')}</Typography>
                                </div>
                                <div>
                                    <Typography color="primary" variant="h6" sx={{ fontWeight: 'bold', color:'#0CC0DF' }} >$ {currencyFormat(_wallet.balance, 2)}</Typography>
                                </div>
                            </div> */}

                            {/* onClick={() => navigate('/wallet-listing', { state: { from: storePaths(location) } })}  */}
                                {/* <div key={_wallet.id} className=' pos-relative p-b-15 pointer w-full'>
                                    <div style={{ minHeight: 150 }}>
                                        <div className={`${WALLET_COLOUR[_wallet.id]} cl-white w-full flex-sb-m flex-col p-all-15`} style={{ borderRadius: 10, boxShadow: '-4px -4px 8px 0px rgba(0, 0, 0, 0.25) inset, 4px 4px 8px 0px rgba(255, 255, 255, 0.63) inset' }}>
                                            <div className='w-full flex-sb-m'>
                                                <div className='p-t-10 p-b-10 w-full' style={{ textShadow: '1px 1px 1px #0000003b' }}>
                                                    <p className='p-b-5'>{_wallet.name[language]}</p>
                                                    <p className='fs-20'><b>{currencyFormat(_wallet.balance, 2)}</b></p>
                                                </div>
                                                <img src={`/images/wallet/${WALLET_ICON[_wallet.id]}`} alt='wallet' style={{ width: 50, opacity: 0.5, filter: ' drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.15))' }} />
                                            </div>
                                            <WalletInfo info={_wallet} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div> */}
            {/* Video */}


            {/* genealogy */}
            {/* <div className='glass-box-hightlight' >
                <div className='bgblack bor10'>
                    <div className='glass-box '>
                        <div className='p-b-8 p-t-10 flex-sb-m w-full' style={{ marginTop: -10 }}>
                            <div className='flex-m'>
                                <Link component={RouterLink} to={`/community/sponsor`} state={{ from: storePaths(location) }} underline='none'>
                                    <p className='txt-upper fs-14 p-b-2 flex-m cl-white'><b>{t('genealogy.myDownline')}</b></p>
                                </Link>
                                <FiChevronRight className='m-l-10 clwhite' />
                            </div>
                            <div className='flex-m'>
                                <p className='fs-12 lh-11 p-r-12 clwhite txt-right'>{t('button.clickFor')}<br />{t('button.referralLink')}</p>
                                <div className='pointer flex-c-m bkg-theme btn-small-square' style={{ width: 30, height: 30 }} onClick={handleClickOpenGeneologyDialog}>
                                    <FaLink style={{ color: '#222' }} />
                                </div>
                            </div>
                        </div>
                        <div className='cl-white flex-sb-m w-full'>
                            <div className='flex-c-m' style={{ width: 130 }}>
                                <img className='w-full' src={`/images/general/genealogy.png`} alt="genealogy" />
                            </div>
                            <div className='w-full p-l-15'>
                                <div className='w-full flex-sb-m'>
                                    <div className='txt-center' style={{ width: '50%' }}>
                                        <p className='fs-17'><b>{data?.downlines?.direct_downlines || 0}</b></p>
                                        <p className='fs-11 txt-upper p-t-5'>{t('genealogy.totalDirect')}</p>
                                    </div>
                                    <div className='txt-center' style={{ width: '50%' }}>
                                        <p className='fs-17'><b>{data?.downlines?.all_downlines || 0}</b></p>
                                        <p className='fs-11 txt-upper p-t-5'>{t('genealogy.total')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <GeneologyDialog dialog={geneologyDialog} handleCloseDialog={handleCloseGeneologyDialog} /> */}


            {/* x3 Earning */}
            {/* <div>
                <div className='glass-box-hightlight' >
                    <div className='bgblack bor10'>
                        <div className='glass-box cl-white'>
                            <div className='flex-sb-m'>
                                <div className='p-b-10 p-t-15'>

                                    <p className='txt-upper fs-12'>{t('home.myPersonalStaking')}</p>
                                    <div className='flex-m'>
                                        <p className='fs-17 p-r-10 p-t-5'><b>{data?.stake?.sum}</b></p>
                                        <div style={{ width: 20, transform: 'rotate(35deg)', marginBottom: -10 }}>
                                            <img src='/images/general/x3.png' alt="x3" />
                                        </div>
                                    </div>

                                </div>
                                <Link component={RouterLink} to={`/stake`} state={{ from: storePaths(location) }} underline='none'>
                                    <FiChevronRight className='fs-20 clwhite' />
                                </Link>
                            </div>
                            <div className='pos-relative'>
                                <div className='progressbar-bkg'></div>
                                <div className='pos-absolute progressbar gradient-main' style={{ top: 0, width: `${((parseFloat(data?.stake?.profit_limit) - parseFloat(data?.stake?.profit_limit_balance)) / parseFloat(data?.stake?.profit_limit) * 100)}%` }}></div>
                            </div>

                            <div className='flex-sb-m fs-12 p-t-10 p-b-10'>
                                <p className='txt-upper'>{t('home.bonusEarn')}</p>
                                <p>{currencyFormat(parseFloat(data?.stake?.profit_limit) - parseFloat(data?.stake?.profit_limit_balance) || 0)} / {currencyFormat(data?.stake?.profit_limit)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='glass-shadow m-t-20'></div>
            </div> */}
            {/* <div className='cl-white' style={{fontWeight:500}}>
                <div className='flex-sb-m'>
                    <p className='title-section'>{t('wallet.bonusSummary')}</p>
                    <Link component={RouterLink} to={`/wallets/commission`} state={{ from: storePaths(location) }} underline='none'><FiChevronRight /></Link>
                </div>
                <div className='flex-sb-m w-full p-t-5'>
                    <p className='fs-14'>{t('wallet.total')}</p>
                    <p className='fs-16 txt-right'><b>{currencyFormat(data?.comm?.all_comm?.total || 0)}</b></p>
                </div>
                <div className='flex-sb-m w-full p-t-5'>
                    <p className='fs-14'>{t('wallet.lastWeek')}</p>
                    <p className='fs-16 txt-right flex-m'>
                    <span className='p-r-10 flex-m' style={{color:'#5CE1E6'}}><HiMiniArrowUpCircle className='m-r-5'/> 65%</span>
                    <b>{currencyFormat(data?.comm?.last_week?.total || 0)}</b></p>
                </div>
            </div> */}

            {/* <Grid container spacing={3}>
                <Grid item xs={12}>
                    <div className='bkg-roi cl-white' style={{ paddingTop: 0 }}>
                        <div className='cut-edge-bottom flex-c-m' style={{ height: 30, width: 250, maxWidth: '90%', margin: '0 auto', }}>
                            <p className='txt-center txt-upper fs-14 cl-theme-darker'><b>ROI {t('wallet.summary')}</b></p>
                        </div>
                        <div className='flex-sb-m w-full p-t-15 p-b-8'>
                            <div>
                                <p className='txt-upper fs-12'>{t('wallet.totalEarn')}</p>
                                <p className='fs-17 p-t-5'>{currencyFormat(data?.comm?.all_comm[1] || 0)}</p>
                            </div>
                            <div style={{ width: 50 }}>
                                <img src='/images/bonus/roi.png' alt='bonus' />
                            </div>
                        </div> */}
                        {/* <div className='pos-relative'>
                        <div className='progressbar-bkg'></div>
                        <div className='pos-absolute progressbar' style={{ top: 0, width: '50%', background:'#fff'}}></div>
                    </div> */}
{/* 
                        <div className='p-t-5'>
                            <div className='flex-sb-m w-full p-t-5'>
                                <p className='fs-14'>{t('wallet.total')}</p>
                                <p className='fs-16 txt-right'><b>{currencyFormat(data?.comm?.all_comm[1] || 0)}</b></p>
                            </div>
                            <div className='flex-sb-m w-full p-t-5'>
                                <p className='fs-14'>{t('wallet.lastWeek')}</p>
                                <p className='fs-16 txt-right flex-m'> */}
                                    {/* <span className='p-r-10 flex-m' style={{ color: '#fff' }}><HiMiniArrowUpCircle className='m-r-5' /> 65%</span> */}{/*<b>{currencyFormat(data?.comm?.last_week[1] || 0)}</b></p> */}
                            {/* </div>
                        </div>

                    </div>
                    <div className='shadow-roi'></div>
                </Grid>

                <Grid item xs={12}>
                    <div className='bkg-matching cl-white' style={{ paddingTop: 0 }}>
                        <div className='cut-edge-bottom flex-c-m' style={{ height: 30, width: 250, maxWidth: '90%', margin: '0 auto', }}>
                            <p className='txt-center txt-upper fs-14 cl-secondary'><b>Matching {t('wallet.summary')}</b></p>
                        </div>
                        <div className='flex-sb-m w-full p-t-15 p-b-8'>
                            <div>
                                <p className='txt-upper fs-12'>{t('wallet.totalEarn')}</p>
                                <p className='fs-17 p-t-5'>{currencyFormat(data?.comm?.all_comm[2] || 0)}</p>
                            </div>
                            <div style={{ width: 50 }}>
                                <img src='/images/bonus/matching.png' alt='bonus' />
                            </div>
                        </div> */}
                        {/* <div className='pos-relative'>
                        <div className='progressbar-bkg'></div>
                        <div className='pos-absolute progressbar' style={{ top: 0, width: '50%', background:'#fff'}}></div>
                    </div> */}

                    {/* <div className='p-t-5'>
                           <div className='flex-sb-m w-full p-t-5'>
                                <p className='fs-14'>{t('wallet.total')}</p>
                                <p className='fs-16 txt-right'><b>{currencyFormat(data?.comm?.all_comm[2] || 0)}</b></p>
                            </div>
                            <div className='flex-sb-m w-full p-t-5'>
                             <p className='fs-14'>{t('wallet.lastWeek')}</p> */}
                             {/*<p className='fs-16 txt-right flex-m'>*/}{/* <span className='p-r-10 flex-m' style={{ color: '#fff' }}><HiMiniArrowUpCircle className='m-r-5' /> 65%</span> */}{/*<b>{currencyFormat(data?.comm?.last_week[2] || 0)}</b></p>*/}
                             {/* </div>
                        </div>

                    </div>
                     <div className='shadow-matching'></div>
                 </Grid>
          </Grid> */}

            {/* wallet */}
            {/* <div >
            <Swiper
                slidesPerView={_.size(data.wallets) > 1 ? 2 : 1}
                spaceBetween={16}
                freeMode={true}
                modules={[FreeMode]}
                style={{ width: "100%" }}
            >
                {data.wallets && _.map(data.wallets, _wallet => {
                    return (
                        <SwiperSlide key={_wallet.id}>
                            <div className={styles.walletBoxStyle}>
                                <div className="dis-flex flex-t flex-l" style={{ flexDirection: 'column' }} >
                                    <div className="flex-c-m" style={{ gap: 8, flexDirection: 'row' }}>
                                        <Typography sx={{ color: '#101828', fontWeight: 'bold' }} variant="subtitle2" >{_wallet.name[i18n.resolvedLanguage]}</Typography>
                                        <ClickAwayListener onClickAway={() => hideWalletTooltip(_wallet.id)}>
                                            <Tooltip
                                                title={<WalletInfo info={_wallet} />}
                                                open={walletTooltip[_wallet.id] || false}
                                                onClose={() => hideWalletTooltip(_wallet.id)}
                                            >
                                                <div onClick={() => showWalletTooltip(_wallet.id)}>
                                                    <FiEye style={{ width: 14, height: 14 }} className={styles.iconHoverStyle} />
                                                </div>
                                            </Tooltip>
                                        </ClickAwayListener>
                                    </div>
                                    <Typography variant="body2" sx={{ color: '#667085' }}>{t('home.currentBalance')}</Typography>
                                </div>
                                <div>
                                    <Typography color="primary" variant="h6" sx={{ fontWeight: 'bold', color:'#0CC0DF' }} >$ {currencyFormat(_wallet.balance, 2)}</Typography>
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
            </div> */}
            {
                (dialogInfo.data && _.size(data?.announcements) > 0)
                &&
                <Dialog
                    maxWidth="xs"
                    fullWidth
                    open={dialogInfo.open}
                    onClose={() => closeDialog()}
                >
                    <DialogDesign>
                        {/* Button Close */}
                        <div className='dialog-btn-close' onClick={() => closeDialog()}>
                            <div className=' flex-c-m animate-spin pointer'>
                                <FiX className='fs-23 cl-theme' />
                            </div>
                        </div>
                            {
                                dialogInfo.data && dialogInfo.data?.content_type === "text" &&
                                <p className='p-lr-20 fs-16 txt-center' style={{ wordBreak: 'break-word' }}>{dialogInfo.data?.title[language]}</p>
                            }
                            <div className='txt-center'>
                                <NoticeItem info={dialogInfo.data} popup={true} />
                            </div>
                    </DialogDesign>
                </Dialog>
            }
        </div>
    )
});

// const useStyles = makeStyles((theme) => ({
//     iconHoverStyle: {
//         color: '#667085',
//         '&:hover': {
//             color: theme.palette.primary.main,
//         }
//     },
//     iconStyle: {
//         color: '#FFFFFF',
//     },
//     walletBoxStyle: {
//         flexDirection: 'column',
//         borderRadius: 18,
//         backdropFilter: 'blur(40px)',
//         backgroundColor: '#F2F4F7',
//         // width: '50%',
//         gap: 16,
//         padding: '21px 57px 21px 15px',
//         display: 'flex',
//         [theme.breakpoints.up('xs')]: {
//             padding: 15,
//         },
//         [theme.breakpoints.up('sm')]: {
//             padding: 15,
//         },
//     },
// }));

export default Home;